import axios from "axios/index";
import api from "../../config/_api";
import {EXTRACTIONS_UPDATED} from "../actions/extractions";
import {isSubscriptionValid} from '../modules/auth';
import { StylingService } from "ag-grid-community";

const state = {
    extractions: []
};
const actions = {
    getExtractions: ({commit, rootGetters}) => {
        let subscriptionOK;
        if(isSubscriptionValid()){subscriptionOK='true';}
        else{subscriptionOK='false';}

        axios({url: api.url + 'extractions?structure_id=' + rootGetters.structure_id + '&' + 'subscriptionOK=' + subscriptionOK, method: 'GET' })
            .then(resp => {
                commit('EXTRACTIONS_UPDATED', resp.data);
            })
         /*   .catch(err => {
                console.log("error");
            });*/
    }
};
const mutations = {
    [EXTRACTIONS_UPDATED]: (state, extractions) => {
        state.extractions = extractions;
    },
};
const getters = {
    extractions : state => state.extractions,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
//# sourceMappingURL=extractions.js.map